exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nli[data-v-381a7914] {\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding: 25px;\n    border-bottom: solid 1px #e7e7e7;\n}\n.addcolor[data-v-381a7914] {\n    color: #ea5858;\n}\n.reducecolor[data-v-381a7914] {\n    color: #59bab1;\n}\n", ""]);

// exports
